import React, { useEffect, useState } from "react";
import Header from "../component/Header";
import { AesDecrypt } from "../middleware/AesDecrypt";
import { AesEncrypt } from "../middleware/AesEncrypt";
import axios from "axios";
import { Base_url } from "../config";
import { useNavigate } from "react-router-dom";
import ReactPaginate from "react-paginate";

const PAGE_LIMIT = 10;

let UserRentedu_copywallet = () => {
  // ---- state ----
  let [data, setData] = useState([]);
  let [count, setCount] = useState(0);
  let [indexs, setIndex] = useState(0);

  let [ selsame, setSelsame ] = useState("fail");

  // "All" | "Success" | "Pending"  (maps to tt.pay === true / false)
  let [payFilter, setPayFilter] = useState("All");
  let [searchValue, setSearchValue] = useState("");

  let navigate = useNavigate();

  useEffect(() => {
    let token = localStorage.getItem("token");
    if (!token) {
      navigate("/login");
      return;
    }
    fetchWalletData(0, "All", "");
  }, []);

  useEffect(() => {
    setIndex(0);
    fetchWalletData(0, payFilter, searchValue);
  }, [payFilter]);

  // ---- helpers ----
  let formatDate = (dateString) => {
    if (!dateString) return "";
    const d = new Date(dateString);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    const hours = String(d.getHours()).padStart(2, "0");
    const minutes = String(d.getMinutes()).padStart(2, "0");
    const seconds = String(d.getSeconds()).padStart(2, "0");
    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
  };

  // ---- api ----
  let fetchWalletData = async (skip, filter, search) => {
    try {
      let token = await localStorage.getItem("token");

      let pp = {
        token,
        limit: PAGE_LIMIT,
        skip,
        filter
      };

      // filter is driven off the boolean "pay" field returned by the API,
      // not the old payment_status_msg string.
      // if (filter !== "All") {
      //   pp.pay = filter === "Success"; // true = wallet payment success, false = failed
      //   pp.search = true;
      // }

      if (search) {
        pp.merchantransactionid = search;
        pp.search = true;
      }

      let encrypted = await AesEncrypt(pp);

      await axios({
        method: "post",
        url: Base_url + "/admin/walletdata",
        data: { data: encrypted },
      })
        .then((res) => {
          let decrypted = AesDecrypt(res.data);
          let json = JSON.parse(decrypted);

          if (json.status === true) {
            setData(json.data || []);
            setCount(json.count || 0);
          } else {
            alert(json.message);
          }
        })
        .catch(() => {});
    } catch (err) {}
  };

  let handlePageClick = (event) => {
    setIndex(event.selected);
    fetchWalletData(event.selected, payFilter, searchValue);
  };

  let handleSearch = () => {
    setIndex(0);
    fetchWalletData(-10, payFilter, searchValue);
  };


  let handlephone = () => {
    setIndex(0);
    setPayFilter("phone");
    fetchWalletData(0, "phone", searchValue);
  };

  let changeStatus = async (id, status) => {

    console.log("changeStatus called with id:", id, "and status:", status);
    try {

      let token = await localStorage.getItem("token");

      let pp = {
        token, 
        id,
        status
      };

       let encrypted = await AesEncrypt(pp);

      await axios({
        method: "post",
        url: Base_url + "/admin/walletdata_update",
        data: { data: encrypted },
      })
        .then((res) => {
          let decrypted = AesDecrypt(res.data);
          let json = JSON.parse(decrypted);

          if (json.status === true) {
            alert("Status updated successfully");
            fetchWalletData(indexs, payFilter, searchValue);
          } else {
            alert(json.message);
          }
        })
        .catch(() => {});


    }catch(err){

    }
  }

  return (
    <div>
      <div className="row">
        <Header />
        <div
          className="col-10"
          style={{ overflowY: "scroll", height: "100vh", scrollbarWidth: "none" }}
        >
          <div className="row">
            <div
              style={{ padding: 10, position: "sticky", top: 0, backgroundColor: "#fff" }}
            >
              <div className="row">
                <div className="col-3">
                  <input
                    onChange={(e) => setSearchValue(e.target.value)}
                    value={searchValue}
                    type="text"
                    style={{ width: "100%" }}
                    placeholder="Enter Merchant Transaction Id"
                  />
                </div>
                <div className="col-1 ">
                  <button onClick={()=>{//
                    setPayFilter("All");
                    handleSearch()
                    }}>Submit</button>
                  <button className="mt-3" onClick={handlephone}>Phone</button>
                </div>
                <div className="col-5">
                  <ReactPaginate
                    breakLabel="..."
                    nextLabel="next >"
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={3}
                    pageCount={Math.ceil(count / PAGE_LIMIT)}
                    previousLabel="< previous"
                    renderOnZeroPageCount={null}
                    containerClassName="pagination justify-content-center"
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="page-item"
                    previousLinkClassName="page-link"
                    nextClassName="page-item"
                    nextLinkClassName="page-link"
                    activeClassName="active"
                    breakClassName="page-item"
                    breakLinkClassName="page-link"
                    forcePage={indexs}
                  />
                </div>
                <div className="col-3">
                  <select
                    value={payFilter}
                    onChange={(e) => setPayFilter(e.target.value)}
                  >
                    <option value="All">All</option>
                    <option value="Success">Wallet Success (pay: true)</option>
                    <option value="Failed">Wallet Failed (pay: false)</option>
                  </select>
                </div>
              </div>
            </div>

            <table className="table">
              <thead
                className="thead-dark"
                style={{ position: "sticky", top: 50, backgroundColor: "#fff" }}
              >
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">User</th>
                  <th scope="col">Wallet Ids</th>
                  <th scope="col">Amount</th>
                  <th scope="col">Reward Wallet</th>
                  <th scope="col">Status</th>
                  <th scope="col">Date</th>
                </tr>
              </thead>
              <tbody>
                {data?.map((tt, index) => {
                  // pay === true  -> successful wallet top-up
                  // pay === false -> not yet paid / pending
                  let isSuccess = tt?.pay === true;

                  return (
                    <tr key={tt?._id} style={{ cursor: "pointer" }}>
                      <th scope="row" style={{ fontWeight: "700" }}>
                        {index + indexs * PAGE_LIMIT + 1}
                      </th>

                      <td>
                        <p style={{ fontWeight: "600", fontSize: 18 }}>{tt?.id?.name}</p>
                        <p
                          style={{
                            marginTop: -12,
                            fontWeight: "500",
                            color: "#252525B8",
                            fontSize: 16,
                          }}
                        >
                          {tt?.id?.phoneno}
                        </p>
                        <p
                          style={{
                            marginTop: -12,
                            fontWeight: "500",
                            color: "#252525B8",
                            fontSize: 16,
                          }}
                        >
                          {tt?.id?.email}
                        </p>
                      </td>

                      <td>
                        <p style={{ fontWeight: "500", fontSize: 16, color: "#252525B8" }}>
                          <span style={{ fontWeight: "600", color: "#4F4F4F" }}>
                            Xopay ID:{" "}
                          </span>
                          {tt?.xopayid}
                        </p>
                        <p
                          style={{
                            fontWeight: "500",
                            fontSize: 16,
                            color: "#252525B8",
                            marginTop: -12,
                          }}
                        >
                          <span style={{ fontWeight: "600", color: "#4F4F4F" }}>
                            Merchant Txn ID:{" "}
                          </span>
                          {tt?.merchantransactionid}
                        </p>
                      </td>

                      <td>
                        <p
                          style={{
                            fontWeight: "700",
                            fontSize: 18,
                            color: isSuccess ? "#0C9C18" : "#252525B8",
                          }}
                        >
                          ₹ {tt?.amount}
                        </p>
                      </td>

                      <td>
                        {tt?.rewardWallet ? (
                          <p style={{ fontWeight: "600", fontSize: 16, color: "#0F3E97" }}>
                            Reward Wallet Credited
                          </p>
                        ) : (
                          <p style={{ fontWeight: "500", fontSize: 16, color: "#252525B8" }}>
                            —
                          </p>
                        )}
                      </td>

                      <td>
                        {isSuccess === false && tt?.refund === false &&  tt?.chargeback
                              === false ? (
                          <p style={{ fontWeight: "700", fontSize: 16, color: "red" }}>
                             Payment Failed
                            </p>
                          ) : isSuccess === true && tt?.refund === false &&  tt?.chargeback
                                === false ? (
                            <p style={{ fontWeight: "700", fontSize: 16, color: "#0C9C18" }}>
                              Payment Success
                            </p>
                          ) : 

                            isSuccess === true && tt?.refund === true &&  tt?.chargeback
                                  === false ? (
                              <p style={{ fontWeight: "700", fontSize: 16, color: "red" }}>
                                Payment Refund
                              </p>
                            )

                            : isSuccess === true && tt?.refund === false &&  tt?.chargeback
                                  === true ? (
                              <p style={{ fontWeight: "700", fontSize: 16, color: "red" }}>
                                Payment Chargeback
                              </p>
                            )

                            : <> </>


                        
                        }
                        {tt?.active === false && (
                          <p style={{ fontWeight: "600", fontSize: 14, color: "red" }}>
                            Inactive
                          </p>
                        )}

                        <select
                          onChange={(e) => {
                            changeStatus(tt?._id, e.target.value);
                          }}
                          name=""
                          id=""
                          style={{ marginLeft: 10 }}
                        >
                          <option
                            value="fail"
                            selected={isSuccess === false && tt?.refund === false &&  tt?.chargeback
                              === false ? true : false}
                              onchange={(e) => {
                                changeStatus(tt?._id, e.target.value);
                                setSelsame(e.target.value);
                              }}
                          >
                            Failed
                          </option>
                          <option
                            value="success"
                            selected={isSuccess === true && tt?.refund === false &&  tt?.chargeback
                              === false ? true : false}
                              onchange={(e) => {
                                changeStatus(tt?._id, e.target.value);
                                setSelsame(e.target.value);
                              }}
                          >
                            Success
                          </option>
                          <option
                            value="refund"
                            selected={isSuccess === true && tt?.refund === true &&  tt?.chargeback
                              === false ? true : false}
                              onchange={(e) => {
                                changeStatus(tt?._id, e.target.value);
                                setSelsame(e.target.value);
                              }}
                          >
                            Refund
                          </option>
                          <option
                            value="chargeback"
                            selected={isSuccess === true && tt?.refund === false &&  tt?.chargeback
                              === true ? true : false  }
                              onchange={(e) => {
                                changeStatus(tt?._id, e.target.value);
                                setSelsame(e.target.value);
                              }}
                          >
                            Chargeback
                          </option>
                        </select>
                      </td>

                      <td>
                        <p style={{ fontWeight: "500", fontSize: 15, color: "#252525B8" }}>
                          {formatDate(tt?.createdAt)}
                        </p>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserRentedu_copywallet;